import { Box, CardMedia, Typography } from "@mui/material";

const TraingingVideo = () => {
    return (
        <>
            <Box marginTop={1} marginBottom={2}>
                <Typography>
                    How to use the application?
                </Typography>
            </Box>
            <Box>
                <CardMedia
                    component="video"
                    controls
                    height="400"
                    src={"https://ireport-qa.s3.ap-south-1.amazonaws.com/Record_2024-07-16-15-23-49.mp4"}
                    title="Video"
                />
            </Box>
        </>
    )
}

export default TraingingVideo;